<template>
  <div v-loading="loading">
      <pt-page-title :title="`${isEdit ? '编辑' :'新建'}咨询师`">
      </pt-page-title>
      <pt-counselor-form ref="form" class="pt-counselor-form__withData" v-model="currentForm"></pt-counselor-form>
      <div class="button-div">
          <el-button type="primary" @click="save">保存</el-button>
          <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
  </div>
</template>

<script>
import PtCounselorForm from './index'
export default {
  name: 'pt-counselor-form__withData',
  components: {
    'pt-counselor-form': PtCounselorForm
  },
  computed: {
    form () {
      return this.$refs.form
    },
    isEdit () {
      return this.$route.params.isEdit !== 'false'
    }
  },
  data () {
    return {
      loading: false,
      currentForm: {

      },
      oldMobile: null
    }
  },
  // watch:{
  //   currentForm(){

  //   }
  // }
  methods: {
    save () {
      this.form.validate().then(formValue => {
        this.changeForm()
        // 编辑咨询师的时候，如果手机号有变化，调用一次验证接口，弹框确认转移数据与否，确定才可编辑，取消不可编辑
        if (this.isEdit) {
          if (this.oldMobile === this.currentForm.mobile) {
            this.edit()
          } else {
            this.getHasMallUser(this.currentForm.mobile)
          }
        } else {
          this.create()
        }
      })
    },
    getHasMallUser (mobile) {
      this.loading = true
      this.$store.dispatch('getHasMallUser', mobile).then(res => {
        this.loading = false
        let text = null
        if (res) {
          text = '更改手机号后，新手机号对应的用户账户将增加咨询师身份，原手机号对应的用户账户将被还原到普通用户身份，确认更改吗？'
        } else {
          text = '改手机号后，原手机号用户账户信息将转移至新的手机号账户，确认更改吗？'
        }
        this.$confirm(text, '更改手机号提示', {
          conformButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(res => {
          this.edit()
        })
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '查询电话号码信息失败')
      })
    },
    changeForm () {
      let copyData = JSON.parse(JSON.stringify(this.currentForm))
      //   copyData.position = copyData.positionName
      //   copyData.company = copyData.companyName
      return copyData
    },
    create () {
      this.loading = true
      console.log('this.changeForm()-------', this.changeForm())
      this.$store.dispatch('createCounselor', this.changeForm()).then(data => {
        this.loading = false
        this.$message.success('创建成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    edit () {
      this.loading = true
      console.log('this.changeForm()-------', this.changeForm())
      this.$store.dispatch('updateCounselor', this.changeForm()).then(data => {
        this.loading = false
        this.$message.success('保存成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    cancel () {
      history.go(-1)
    },
    getForm (data) {
      if (data.base.licenseUrl.length) {
        data.base.licenseUrl = data.base.licenseUrl.map(e => {
          return {
            name: e,
            url: e
          }
        })
      }
      if (data.base.contractUrl.length) {
        data.base.contractUrl = data.base.contractUrl.map(e => {
          return {
            name: e,
            url: e
          }
        })
      }
      return data
    },
    load () {
      this.loading = true
      this.$store.dispatch('getCounselor', this.$route.params.id).then(data => {
        this.loading = false
        this.currentForm = data
        this.oldMobile = data.mobile
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    if (this.isEdit) {
      this.load()
    }
  }
}
</script>
